export default "__VITE_ASSET__BsNwSKs6__"